module.exports = __webpack_public_path__ + "assets/img/ea01957e4dada0d84e9d8c0f85d8b927.svg";